import { NotaPromissoria } from "../types";

/**
 * Numeração dos contratos de NP, espelhando R/xama_np.R: sequencial, com zeros
 * à esquerda até 6 dígitos ("000043"), e o documento sempre "NP" + id_contrato
 * ("NP000043").
 *
 * Quem numera de fato é o backend, dentro da transação de criação — aqui a
 * mesma regra roda só para prever os números no formulário.
 */
export const LARGURA_ID_CONTRATO = 6;

export const formatarIdContrato = (numero: number): string =>
  String(numero).padStart(LARGURA_ID_CONTRATO, "0");

export const numeroDocumentoDe = (idContrato: string): string => `NP${idContrato}`;

/** Maior id_contrato numérico já cadastrado; 0 quando não há nenhum. */
export const ultimoIdContrato = (
  existentes: Pick<NotaPromissoria, "id_contrato">[]
): number =>
  existentes.reduce((maior, np) => {
    const valor = /^\d+$/.test(np.id_contrato) ? parseInt(np.id_contrato, 10) : 0;
    return Math.max(maior, valor);
  }, 0);

/** Os `quantidade` próximos números da sequência, já formatados. */
export const proximosIdContratos = (
  existentes: Pick<NotaPromissoria, "id_contrato">[],
  quantidade: number
): string[] => {
  const base = ultimoIdContrato(existentes);
  return Array.from({ length: Math.max(quantidade, 0) }, (_, i) =>
    formatarIdContrato(base + 1 + i)
  );
};
